export default __webpack_public_path__ + "static/media/2_my_hotel_shop.7442b374.svg";